import { dayjs } from "@thalamos/common";

/** A calendar day as Haven spells one; days in this spelling sort as strings. */
export const CALENDAR_DAY = "YYYY-MM-DD";

/** The zone an instant's calendar day is read in. */
// TODO(time-zone): take the zone from the acting organisation once Haven is
// used anywhere other than the UK.
export const CALENDAR_TIME_ZONE = "Europe/London";

/**
 * The calendar day an instant falls on in the UK, or `undefined` for an instant
 * that cannot be read.
 */
export const calendarDayOf = (instant: Date | string): string | undefined => {
  const read = dayjs(instant);

  return read.isValid()
    ? read.tz(CALENDAR_TIME_ZONE).format(CALENDAR_DAY)
    : undefined;
};

/**
 * Whether one calendar day falls after another. Both must be `CALENDAR_DAY`
 * strings, which sort as the days they name.
 */
export const isLaterDay = (day: string, than: string): boolean => day > than;

/** Today in the UK. */
export const today = (): string =>
  dayjs().tz(CALENDAR_TIME_ZONE).format(CALENDAR_DAY);

/**
 * The last instant of a UK calendar day: the millisecond before the next day
 * begins, whatever the clocks do in between. The day must already be a valid
 * `CALENDAR_DAY`: one it cannot read gives an Invalid Date, and an out-of-range
 * one rolls over, without throwing.
 */
export const endOfDay = (day: string): Date => {
  // The next day is worked out on the calendar alone, in UTC, so a day on
  // which the clocks change is still one day long here.
  const next = dayjs.utc(day, CALENDAR_DAY).add(1, "day").format(CALENDAR_DAY);

  return new Date(
    dayjs.tz(next, CALENDAR_DAY, CALENDAR_TIME_ZONE).valueOf() - 1,
  );
};
